import * as React from "react";
import { UIDataModel } from "../uicomponent";
import { UIComponentViewImpl } from "../uicomponentview";
import { SwitchHandler, SwitchProps, SwitchState } from "./switchcomponent";
import "./switchstyle.css";
import { SwitchCSSStyle } from "./switchcss";

export class SwitchView extends UIComponentViewImpl<UIDataModel>{


    bindHandlers():void
    {
        this.onChange = this.onChange.bind(this);
    }
    draw(uiProps: SwitchProps, uiState: SwitchState, cssStyle: SwitchCSSStyle): JSX.Element | boolean{
        super.draw(uiProps, uiState, cssStyle);
        
        return(
           <>
               <div>
               {
                   this.getWebView(uiProps, uiState, cssStyle)
               }
            </div>
            {/* <div id="toggle-botton-col-wrapper">
                {
                    this.getMobileView(uiProps, uiState, cssStyle)
                }
            </div> */}
           </>
        );
    }

    getWebView(uiProps: SwitchProps, uiState: SwitchState, cssStyle: SwitchCSSStyle)
    {
        return(
            // <button style={uiState.style.getButtonStyle(uiProps.isSelected)} onClick={uiProps.onClick}>
            //     <label style={uiState.style.getButtonText(uiProps.isSelected)}>{uiState.label}</label><br/>
            // </button> 
          <label className="switch">
                <input onChange={(e)=>this.onChange(e,uiState)} checked={uiState.isChecked}   type="checkbox" defaultChecked={uiState.isChecked}/>
                <span className="slider round"/>
          </label>
        );
    }

    onChange(e:React.ChangeEvent<HTMLInputElement>,state:SwitchState):void{
         
            console.log("switch onChange:",e.target.value);

           
            (this.getUIComponentHandler() as SwitchHandler).onChange(!state.isChecked);

            
          

    }
    getMobileView(uiProps: SwitchProps, uiState: SwitchState, cssStyle: SwitchCSSStyle)
    {
        return(
            // <button style={uiState.style.getMobileButtonStyle(uiProps.isSelected)} onClick={uiProps.onClick}>
            //     <label style={uiState.style.getMobileButtonText(uiProps.isSelected)}>{uiState.label}</label><br/>
            // </button> 
             <label id="switch">
             <input type="checkbox"/>
             <span id="slider round"/>
            </label>
        );
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/switch/switchview.tsx